var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.224 24.9839L13.7542 34.4536C12.7486 35.4592 12.7486 37.2191 13.7542 38.2247C14.7599 39.2304 16.5197 39.2304 17.5254 38.2247L26.9951 28.755",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7775 29.1741L37.9733 34.3698C38.9789 35.3754 38.9789 37.1353 37.9733 38.1409C36.9676 39.1466 35.2078 39.1466 34.2021 38.1409L25.9056 29.8445",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7823 18.6986L15.933 19.6204L13.0837 14.9275L15.0112 13L19.7042 15.8493L18.7823 18.6986ZM18.7823 18.6986L22.5535 22.4698",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.224 24.9839C22.1345 22.1346 22.3021 18.3635 24.6486 16.017C26.9951 13.6705 31.269 13.1677 33.6155 14.5924L29.593 18.6149L29.174 22.805L33.3641 22.386L37.3867 18.3635C38.8113 20.71 38.3085 24.9839 35.962 27.3304C33.6155 29.6769 29.8444 29.8445 26.9951 28.7551",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.73bcdaa504f82f9a012b1cfdd7e824e7.svg";
export { ForwardRef as ReactComponent };